import { Config } from "../config/config.js";

export class EditorBroadcastChannel {
    private broadcastChannel: BroadcastChannel;
    private window: Window;
    private intervalId;
    public channel;
    public metadataType;
    public onRequestMetadata;
    public onMetadataChanged;
    public onEditorOpenedClosed;

    constructor(onRequestMetadata, onMetadataChanged, onEditorOpenedOrClosed) {
        if (this.isBroadcastChannelSupported()) {
            this.onRequestMetadata = onRequestMetadata;
            this.channel = kendo.guid();
            this.broadcastChannel = new BroadcastChannel(this.channel);
            this.broadcastChannel.onmessage = this.onMessage;
            this.onMetadataChanged = onMetadataChanged;
            this.onEditorOpenedClosed = onEditorOpenedOrClosed;
        }
    }

    private onMessage = (ev: MessageEvent) => {
        if (ev.data.message == "GETMETA") {
            this.onRequestMetadata && this.onRequestMetadata();
        }
        else if (ev.data.message == "METACHANGED") {
            this.onMetadataChanged && this.onMetadataChanged(ev.data.metadata);
        }
    }

    public isBroadcastChannelSupported(): boolean {
        return typeof BroadcastChannel !== 'undefined';
    }

    public isConnectedToEditor(): boolean {
        return this.window != null;
    }

    public openEditorPopup(metadataType: string): void {
        if (this.window) {
            return;
        }
        this.window = window.open(Config.baseUrl + `UiEditor/UiEditorWebPage?channel=${this.channel}&metadataType=${metadataType}`, '', 'width=800,height=' + screen.height);

        this.onEditorOpenedClosed && this.onEditorOpenedClosed();

        this.intervalId = setInterval(() => {
            if (this.window.closed) {
                this.window = null;
                clearInterval(this.intervalId);
                this.onEditorOpenedClosed && this.onEditorOpenedClosed();
            }
        }, 100);
    }

    public sendMetadata(entity) {
        try {
            this.broadcastChannel.postMessage({ message: "SENDMETA", entity: entity });
        } catch (e) {
        }
    }
}